import {clearFeedbacksByName, getInputsByName} from "../../helpers/forms";
import Axios from "axios";

/**
 *
 * @param {Element} formElement
 */
function initVoeThirdPartyCompanyForm(formElement) {

	// Form methods
	return {
		formElement,
		formFields: [
			'id',
			'name',
			'email',
			'phone',
			'fax',
		],
		inputs() {
			return getInputsByName(formElement, this.formFields);
		},
		clearFeedbacks() {
			return clearFeedbacksByName(formElement, this.formFields);
		},
		postRoute() {
			// noinspection JSUnresolvedVariable
			return formElement.dataset.postRoute;
		},
		submit() {
			return Axios.post(this.postRoute(), this.inputs())
		}
	};
}

export {initVoeThirdPartyCompanyForm}
